import React from 'react';

interface StarOutlinedProps {
  color?: string;
  className?: string;
}

export const StarOutlined: React.FC<StarOutlinedProps> = ({ color = '#5E5E79', className = '' }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.47211 3.08684C9.05361 1.7523 10.9465 1.7523 11.528 3.08684L12.9883 6.43829L16.7067 6.72285C18.2062 6.8376 18.7988 8.72295 17.6346 9.67491L14.8597 11.9438L15.7174 15.3759C16.0749 16.8066 14.5349 17.9626 13.261 17.2198L10 15.3186L6.73908 17.2198C5.46511 17.9626 3.92515 16.8066 4.28267 15.3759L5.14034 11.9438L2.36549 9.67491C1.20126 8.72295 1.79382 6.8376 3.29332 6.72285L7.01179 6.43829L8.47211 3.08684ZM10 3.7526L8.53971 7.10405C8.2932 7.66979 7.75427 8.05301 7.13896 8.1001L3.42049 8.38466L6.19534 10.6536C6.69481 11.062 6.9137 11.722 6.75728 12.3479L5.89962 15.78L9.16057 13.8787C9.67934 13.5763 10.3207 13.5763 10.8395 13.8787L14.1004 15.78L13.2428 12.3479C13.0864 11.722 13.3053 11.062 13.8047 10.6536L16.5796 8.38466L12.8611 8.1001C12.2458 8.05301 11.7069 7.66979 11.4604 7.10405L10 3.7526Z"
        fill={color}
      />
    </svg>
  );
};
